import { Component, OnInit } from "@angular/core";
import { ProductTile } from "../models/product-tile.model";
import { Router, ActivatedRoute } from "@angular/router";
//import { ActivatedRoute } from "@angular/router";
import { ProductDetailsService } from "../ApplicationServices/ProductDetailsService";
import { SliderScrollService } from "../ApplicationServices/SliderScrollService";
import { CollectionService } from '../ApplicationServices/CollectionService';
import { ItemModifierService } from "src/app/ApplicationServices/ItemModifierServices";
import { UserInfoStore } from "../shared/store/userInfo.store";

//import { Router } from "@angular/router";


@Component({
  selector: "app-single-product",
  templateUrl: "./single-product.component.html",
  styleUrls: ["./single-product.component.scss"],
})
export class SingleProductComponent implements OnInit {

  COUPON_CODE : string = null;
  COUPON_AMT : string = null; EXPIRY_DATE : string = null;
  COUPON_RS: string = null; COUPON_PERCENT: string = null;

  brandname : string = null;
  skuname :   string = null;

  mensCollectionListLaptopBags: Array<ProductTile[]> = [];

  partner_AMAZON: boolean = true;

  partner_AMAZON_ORDER: boolean = true;
  partner_AMAZON_REVIEW: boolean = true;

  CAP: boolean = true;
  CAP1: boolean = true; CAP2: boolean = true; CAP3: boolean = true;
  CK: boolean = true;

  relatedProductTileList: Array<ProductTile[]> = [];
  upsellProductTileList: Array<ProductTile[]> = [];

  outermaterial : string = null;

  Description1 : string = null;
  Description2 : string = null;
  Description3 : string = null;
  Description4 : string = null;
  Description5 : string = null;
  Description6 : string = null;
  Description7 : string = null;
  Description8 : string = null;
  Description9 : string = null;
  Description10 : string = null;

  Description11 : string = null;
  Description22 : string = null;
  Description33 : string = null;
  Description44 : string = null;
  Description55 : string = null;
  Description66 : string = null;
  Description77 : string = null;
  Description88 : string = null;
  Description99 : string = null;
  Description100 : string = null;

  DescriptionINTRODUCTION : string = null;
  DescriptionDURABLE : string = null;
  DescriptionRFID : string = null;
  DescriptionSMARTDESIGN : string = null;
  DescriptionCOMPACT : string = null;
  DescriptionGIFTING : string = null;

  GIFTINGSOLUTIONFORMEN : string = null;
  Genuineleather : string = null;
  Adjustablesize : string = null;
  MATERIALANDDESIGEN : string = null;
  MECHANISM : string = null;
  NewMechanism : string = null;


  SpeciModelNumber : string = null;
  SpeciItemHeight : string = null;
  SpeciItemLength : string = null;
  SpeciItemWidth : string = null;
  SpeciItemWeight : string = null;
  SpeciMaterial : string = null;
  SpeciSpecialFeatures : string = null;
  SpeciInnerMaterial : string = null;
  SpeciWarrantyDescription : string = null;
  SpeciWarrantyType : string = null;
  SpeciProductDimensions : string = null;
  //SpeciModelNumber : string = null;

  Link : string = null;
  ImportantPointsLEGAL : string = null;
  ImportantPointsSAFETY : string = null;

  _SKUCODE_ : string = null;
  _SKUCODEG_ : string = null;  _SKUCODEQ_ : string = null;
  _Status_  : string = null;

  currentQuickView:ProductTile;
  showQuickView:boolean=false;
  //detailedService: ProductDetailsService;

  productTileList: ProductTile[] = [];
  currentItem: ProductTile;
  productdescService: ProductDetailsService;

  showProductDetails: boolean = false;

  // //////////////////////////////////////////////

  COUPON_BLOCK: boolean = false;

  wt :number =0;
  WarrantyType: boolean = false;
  ProductDimensions: boolean = false;
  LEGALDISCLAIMER: boolean = false;

 COUNT :number=0;

  Description_INTRODUCTION_NO :number =0;
  Description_INTRODUCTION_CK: boolean = false;

  Description_COMPACT_STYLISH_NO :number =0;
  Description_COMPACT_STYLISH_CK: boolean = false;

  Description_SMART_DESIGN_NO :number =0;
  Description_SMART_DESIGN_CK: boolean = false;

  Description_DURABLE_MATERIAL_NO :number =0;
  Description_DURABLE_MATERIAL_CK: boolean = false;

  Description_RFID_BLOCKING_TECHNOLOGY_NO :number =0;
  Description_RFID_BLOCKING_TECHNOLOGY_CK: boolean = false;

  Description_GIFTING_SOLUTION_NO :number =0;
  Description_GIFTING_SOLUTION_CK: boolean = false;

  Description_GIFTING_SOLUTION_FOR_MEN_NO :number =0;
  Description_GIFTING_SOLUTION_FOR_MEN_CK: boolean = false;

  Description_Genuine_leather_NO :number =0;
  Description_Genuine_leather_CK: boolean = false;

  Description_Adjustable_size_NO :number =0;
  Description_Adjustable_size_CK: boolean = false;

  Specification_Model_Number_NO :number =0;
  Specification_Model_Number_CK: boolean = false;

  Specification_Item_Height_NO :number =0;
  Specification_Item_Height_CK: boolean = false;

  Specification_Item_Length_NO :number =0;
  Specification_Item_Length_CK: boolean = false;

  Specification_Item_Width_NO :number =0;
  Specification_Item_Width_CK: boolean = false;

  Specification_Item_Weight_NO :number =0;
  Specification_Item_Weight_CK: boolean = false;

  Specification_Material_NO :number =0;
  Specification_Material_CK: boolean = false;

  Specification_Special_Features_NO :number =0;
  Specification_Special_Features_CK: boolean = false;

  Specification_Inner_Material_NO :number =0;
  Specification_Inner_Material_CK: boolean = false;

  Specification_Warranty_Description_NO:number =0;
  Specification_Warranty_Description_CK: boolean = false;

  Specification_Warranty_Type_NO:number =0;
  Specification_Warranty_Type_CK: boolean = false;

  Specification_Product_Dimensions_NO:number =0;
  Specification_Product_Dimensions_CK: boolean = false;

  Specification_NO:number =0;
  Specification_CK: boolean = false;

  ImportantPoints_LEGAL_DISCLAIMER_NO:number =0;
  ImportantPoints_LEGAL_DISCLAIMER_CK: boolean = false;

  ImportantPoints_SAFETY_CAUTION_NO:number =0;
  ImportantPoints_SAFETY_CAUTION_CK: boolean = false;

  ImportantPoints1_NO:number =0;
  ImportantPoints1_CK: boolean = false;

  ImportantPoints2_NO:number =0;
  ImportantPoints2_CK: boolean = false;

  ImportantPoints3_NO:number =0;
  ImportantPoints3_CK: boolean = false;

  OuterMaterial_NO:number =0;
  OuterMaterial_CK: boolean = false;

  Description_MATERIAL_DESIGEN_NO:number =0;
  Description_MATERIAL_DESIGEN_CK: boolean = false;

  Description_MECHANISM_NO:number =0;
  Description_MECHANISM_CK: boolean = false;

  Description_New_Mechanism_NO:number =0;
  Description_New_Mechanism_CK: boolean = false;



  //////////////////////////////////////////////

  showRelatedProductDetails: boolean = false;
  showUPSELLProductDetails: boolean = false;


  description: any=[];
  private sub: any;
  isNewProductAvailable:boolean=false;

  relatedProduct : string=null;
  str : string=null;
  showPic=true;

  isProductAvailable: boolean = false;
  proname: string = null;
  isMensCollectionAvailable: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private detailService: ProductDetailsService,
    private sliderService: SliderScrollService,
    private collservice : CollectionService,
    private itemModifierService: ItemModifierService,
    private infoStore: UserInfoStore,
    private router: Router,
    //private proService: ProductDetailsService
  )
  {

    this.productdescService = detailService;

  }


  COUPON_PARAMETERS(){

  //   SUCCESS#DYNAMIC#AMOUNT#100.00#02/07/2022
  this.detailService.GetAllItemMasterBasic8_CouponDetailsByCouponCode('0','0').subscribe((datas) => {
    
    
    var C_nature ; var C_category ; var C_amt; var C_expiry;  var C_code;
      
    var str = datas[0].OperationStatus;
    str = datas[0].OperationStatus.toString().split("#")[0];

    if(  str=='FAIL' ){

      str= datas[0].OperationStatus.toString().split("#")[1];
      C_amt=0;

        //this.total = this.total ;
       //this.FillCouponFrid();


    }else{


      //str= datas[0].MASSIVE.toString().split("#")[1];
     
      C_nature= datas[0].OperationStatus.toString().split("#")[1];
      C_category= datas[0].OperationStatus.toString().split("#")[2];
      C_amt= datas[0].OperationStatus.toString().split("#")[3];
      C_expiry= datas[0].OperationStatus.toString().split("#")[4];
      C_code= datas[0].OperationStatus.toString().split("#")[5];
 

      this.COUPON_AMT=C_amt.toString();
      this.EXPIRY_DATE=C_expiry.toString();
      this.COUPON_CODE=C_code.toString();

      if( C_category =='AMOUNT' ){

        this.COUPON_RS="Rs";
        this.COUPON_PERCENT="";
       
      }else{

        this.COUPON_RS="";
        this.COUPON_PERCENT="%";

      }

    }


    });


  }

  CouponVisibility(){

      // this.COUPON_BLOCK=true;
     //  return;

       // ------------------  COUPON BLOCK VISIBILITY --------------------///////////////////

      this.detailService.GetAllItemMasterHeaderSubDescByIdSubIdFetch( 9, 3504 ).subscribe((datas) => {
    
                 
      var str = datas[0].ItemMasterHeaderSubDesc;
    
  
      if(  str=='YES' ){
  

       this.COUPON_BLOCK=true;

       this.COUPON_PARAMETERS();

  
  
      }else{
  
        this.COUPON_BLOCK=false;
        
  
      }
  
  
  
      });


  }


  

  ngOnInit() {

    //this.onViewNewArrivalProductAll();

    this.COUPON_BLOCK=false;
    this.CouponVisibility();

    this.partner_AMAZON=false;
    
    this.partner_AMAZON_ORDER=false;
    this.partner_AMAZON_REVIEW=false;


    this.CAP=false;   
    this.CK=false;

    this.CAP1=false; this.CAP2=false; this.CAP3=false;

    this.onViewMensAllLAPTOP("Laptop Bag");

    

    window.scrollTo(0, 0);
    this.sub = this.route.params.subscribe((params) => {
      this.showProductDetails = false;
      // this.productListAvailable = false;
      var arg = params["itemId"];
      const itemId = arg.split("&")[0];
      const SKU = arg.split("&")[1];
      this._SKUCODE_= arg.split("&")[1];

      this.productdescService
      .getProductDetailsBySKUData(SKU)
      .subscribe((data: any) => this.manageRes(data));


    });

    for (let index = 0; index < 4; index++) {
      var prod = new ProductTile();
      prod.CurrentPrize = "$35.00";
      prod.HotLabel = "BEST SALLER";
      prod.OldPrize = "$55.00";
      prod.ProductTileImgURL1 = "../../../assets/styles/images/books/1.jpg";
      prod.ProductBlockImgURL = "../../../assets/styles/images/product/2.jpg";
      prod.ProductName = "robin parrish";
      prod.ProductURL = "#/single-product";
      prod.ProductDescription =
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam fringilla augue nec est tristique auctor. Donec non est at libero vulputate rutrum. Morbi ornare lectus quis justo gravida semper. Nulla tellus mi, vulputate adipiscing cursus eu, suscipit id nulla.";
      this.productTileList.push(prod);

      //  *ngIf="CAP"
    //  if( prod.CurrentPrize =="" )
    //  {


    //  }
    //  else
    //  {


    //  }




    }


    this.VIEWPARTNER_LINK();

    // this.sub = this.route.params.subscribe((params) => {
    //   this.showProductDetails = false;
    //   var arg = params["itemId"];
    //   const itemId = arg.split("&")[0];
    //   const SKU = arg.split("&")[1];

    //   this.productdescService
    //   .getProductDetailsBySKUData(SKU)
    //     .subscribe((data: any) => this.manageRes(data));


    // });

    // for (let index = 0; index < 4; index++) {
    //   var prod = new ProductTile();
    //   prod.CurrentPrize = "$35.00";
    //   prod.HotLabel = "BEST SALLER";
    //   prod.OldPrize = "$55.00";
    //   prod.ProductTileImgURL1 = "../../../assets/styles/images/books/1.jpg";
    //   prod.ProductBlockImgURL = "../../../assets/styles/images/product/2.jpg";
    //   prod.ProductName = "robin parrish";
    //   prod.ProductURL = "#/single-product";
    //   prod.ProductDescription =
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam fringilla augue nec est tristique auctor. Donec non est at libero vulputate rutrum. Morbi ornare lectus quis justo gravida semper. Nulla tellus mi, vulputate adipiscing cursus eu, suscipit id nulla.";
    //   this.productTileList.push(prod);
    // }


      // this.onViewUpsellProductAll();

    // this.onViewNewArrivalProductAll();

    this.WarrantyType = false;

    this.productdescService
    .getAllSKUHeaderMAPPINGSKUCodeData( this._SKUCODE_ )
    .subscribe((event: any) => {
      if (event.length > 0) {


        ////////////////////////////////////
    //     this.Description_INTRODUCTION_NO  =event[0].IsPermitted;
    //     if(this.Description_INTRODUCTION_NO == 0){
    //       this.Description_INTRODUCTION_CK = true;
    //     }else{
    //      this.Description_INTRODUCTION_CK = false;
    //     }
    //    /////////////////////////////////////////
    //    this.Description_COMPACT_STYLISH_NO  =event[1].IsPermitted;
    //    if(this.Description_COMPACT_STYLISH_NO == 0){
    //      this.Description_COMPACT_STYLISH_CK = true;
    //    }else{
    //     this.Description_COMPACT_STYLISH_CK = false;
    //    }
    //   ///////////////////////////////////////////////
    //   this.Description_SMART_DESIGN_NO  =event[2].IsPermitted;
    //   if(this.Description_SMART_DESIGN_NO == 0){
    //     this.Description_SMART_DESIGN_CK = true;
    //   }else{
    //    this.Description_SMART_DESIGN_CK = false;
    //   }
    // //////////////////////////////////////////////////
    // this.Description_DURABLE_MATERIAL_NO  =event[3].IsPermitted;
    //   if(this.Description_DURABLE_MATERIAL_NO == 0){
    //     this.Description_DURABLE_MATERIAL_CK = true;
    //   }else{
    //    this.Description_DURABLE_MATERIAL_CK = false;
    //   }
    //  //////////////////////////////////////////////////
    //  this.Description_RFID_BLOCKING_TECHNOLOGY_NO  =event[4].IsPermitted;
    //   if(this.Description_RFID_BLOCKING_TECHNOLOGY_NO == 0){
    //     this.Description_RFID_BLOCKING_TECHNOLOGY_CK = true;
    //   }else{
    //    this.Description_RFID_BLOCKING_TECHNOLOGY_CK = false;
    //   }
    //   ////////////////////////////////////////////////
    //   this.Description_GIFTING_SOLUTION_NO  =event[5].IsPermitted;
    //   if(this.Description_GIFTING_SOLUTION_NO == 0){
    //     this.Description_GIFTING_SOLUTION_CK = true;
    //   }else{
    //    this.Description_GIFTING_SOLUTION_CK = false;
    //   }
    //   /////////////////////////////////////////////////
    //   this.Description_GIFTING_SOLUTION_FOR_MEN_NO  =event[6].IsPermitted;
    //   if(this.Description_GIFTING_SOLUTION_FOR_MEN_NO == 0){
    //     this.Description_GIFTING_SOLUTION_FOR_MEN_CK = true;
    //   }else{
    //    this.Description_GIFTING_SOLUTION_FOR_MEN_CK = false;
    //   }
    //   /////////////////////////////////////////////////
    //   this.Description_Genuine_leather_NO  =event[7].IsPermitted;
    //   if(this.Description_Genuine_leather_NO == 0){
    //     this.Description_Genuine_leather_CK = true;
    //   }else{
    //    this.Description_Genuine_leather_CK = false;
    //   }
    //   ///////////////////////////////////////////////////////
    //   this.Description_Adjustable_size_NO  =event[8].IsPermitted;
    //   if(this.Description_Adjustable_size_NO == 0){
    //     this.Description_Adjustable_size_CK = true;
    //   }else{
    //    this.Description_Adjustable_size_CK = false;
    //   }
      //////////////////////////////////////////////////


      this.Specification_Model_Number_NO  =event[9].IsPermitted;
      if(this.Specification_Model_Number_NO == 0){
        this.Specification_Model_Number_CK = false;
      }else{
       this.Specification_Model_Number_CK = false;
      }
      ///////////////////////////////////////////////////
      this.Specification_Item_Height_NO  =event[10].IsPermitted;
      if(this.Specification_Item_Height_NO == 0){
        this.Specification_Item_Height_CK = false;
      }else{
       this.Specification_Item_Height_CK = false;
      }
      /////////////////////////////////////////////////////
      this.Specification_Item_Length_NO  =event[11].IsPermitted;
      if(this.Specification_Item_Length_NO == 0){
        this.Specification_Item_Length_CK = true;
      }else{
       this.Specification_Item_Length_CK = false;
      }
      ////////////////////////////////////////////////////////
      this.Specification_Item_Width_NO  =event[12].IsPermitted;
      if(this.Specification_Item_Width_NO == 0){
        this.Specification_Item_Width_CK = false;
      }else{
       this.Specification_Item_Width_CK = false;
      }
      //////////////////////////////////////////////////////////
      this.Specification_Item_Weight_NO  =event[13].IsPermitted;
      if(this.Specification_Item_Weight_NO == 0){
        this.Specification_Item_Weight_CK = true;
      }else{
       this.Specification_Item_Weight_CK = false;
      }
      ////////////////////////////////////////////////////////
      this.Specification_Material_NO  =event[14].IsPermitted;
      if(this.Specification_Material_NO == 0){
        this.Specification_Material_CK = true;
      }else{
       this.Specification_Material_CK = false;
      }
      /////////////////////////////////////////////////////////
      this.Specification_Special_Features_NO  =event[15].IsPermitted;
      if(this.Specification_Special_Features_NO == 0){
        this.Specification_Special_Features_CK = true;
      }else{
       this.Specification_Special_Features_CK = false;
      }
      /////////////////////////////////////////////////////
      this.Specification_Inner_Material_NO  =event[16].IsPermitted;
      if(this.Specification_Inner_Material_NO == 0){
        this.Specification_Inner_Material_CK = true;
      }else{
       this.Specification_Inner_Material_CK = false;
      }
      ////////////////////////////////////////////////////
      this.Specification_Warranty_Description_NO  =event[17].IsPermitted;
      if(this.Specification_Warranty_Description_NO == 0){
        this.Specification_Warranty_Description_CK = true;
      }else{
       this.Specification_Warranty_Description_CK = false;
      }
      ////////////////////////////////////////////////////
      this.Specification_Warranty_Type_NO  =event[18].IsPermitted;
      if(this.Specification_Warranty_Type_NO == 0){
        this.Specification_Warranty_Type_CK = false;
      }else{
       this.Specification_Warranty_Type_CK = false;
      }
      /////////////////////////////////////////////////////////
      this.Specification_Product_Dimensions_NO  =event[19].IsPermitted;
      if(this.Specification_Product_Dimensions_NO == 0){
        this.Specification_Product_Dimensions_CK = true;
      }else{
       this.Specification_Product_Dimensions_CK = false;
      }
      /////////////////////////////////////////////////////////
      // this.Specification_NO  =event[20].IsPermitted;
      // if(this.Specification_NO == 0){
      //   this.Specification_CK = true;
      // }else{
      //  this.Specification_CK = false;
      // }
      //////////////////////////////////////////
      this.ImportantPoints_LEGAL_DISCLAIMER_NO  =event[21].IsPermitted;
      if(this.ImportantPoints_LEGAL_DISCLAIMER_NO == 0){
        this.ImportantPoints_LEGAL_DISCLAIMER_CK = true;
      }else{
       this.ImportantPoints_LEGAL_DISCLAIMER_CK = false;
      }
      //////////////////////////////////////////////
      this.ImportantPoints_SAFETY_CAUTION_NO  =event[22].IsPermitted;
      if(this.ImportantPoints_SAFETY_CAUTION_NO == 0){
        this.ImportantPoints_SAFETY_CAUTION_CK = true;
      }else{
       this.ImportantPoints_SAFETY_CAUTION_CK = false;
      }
      ////////////////////////////////////////////////
      // this.ImportantPoints1_NO  =event[23].IsPermitted;
      // if(this.ImportantPoints1_NO == 0){
      //   this.ImportantPoints1_CK = true;
      // }else{
      //  this.ImportantPoints1_CK = false;
      // }
      // //////////////////////////////////////////////////
      // this.ImportantPoints2_NO  =event[24].IsPermitted;
      // if(this.ImportantPoints2_NO == 0){
      //   this.ImportantPoints2_CK = true;
      // }else{
      //  this.ImportantPoints2_CK = false;
      // }
      // ///////////////////////////////////////////////////
      // this.ImportantPoints3_NO  =event[25].IsPermitted;
      // if(this.ImportantPoints3_NO == 0){
      //   this.ImportantPoints3_CK = true;
      // }else{
      //  this.ImportantPoints3_CK = false;
      // }
      //////////////////////////////////////////
      this.OuterMaterial_NO  =event[26].IsPermitted;
      if(this.OuterMaterial_NO == 0){
        this.OuterMaterial_CK = true;
      }else{
       this.OuterMaterial_CK = false;
      }
      ////////////////////////////////////////////
      this.Description_MATERIAL_DESIGEN_NO  =event[27].IsPermitted;
      if(this.Description_MATERIAL_DESIGEN_NO == 0){
        this.Description_MATERIAL_DESIGEN_CK = true;
      }else{
       this.Description_MATERIAL_DESIGEN_CK = false;
      }
      /////////////////////////////
      this.Description_MECHANISM_NO  =event[28].IsPermitted;
      if(this.Description_MECHANISM_NO == 0){
        this.Description_MECHANISM_CK = true;
      }else{
       this.Description_MECHANISM_CK = false;
      }
      /////////////////////////////
      this.Description_New_Mechanism_NO  =event[29].IsPermitted;
      if(this.Description_New_Mechanism_NO == 0){
        this.Description_New_Mechanism_CK = true;
      }else{
       this.Description_New_Mechanism_CK = false;
      }


      }
    });


  }




  
  onViewMensAllLAPTOP(pronames) {

    this.proname = pronames;

    if (this.proname != "ALL") {


      this.collservice.getAllMENSCOLLECTION_NAMEData(pronames).subscribe((data: any) => {

        //this.isMensCollectionAvailable=false;
        this.mensCollectionListLaptopBags = [];
        let carouselIndex = 0; this.mensCollectionListLaptopBags[carouselIndex] = [];
        for (let index = 0; index < data.length; index++) {
          if (index !== 0 && index % 4 == 0) {
            carouselIndex = carouselIndex + 1;
            this.mensCollectionListLaptopBags[carouselIndex] = [];
          }
          let prod = new ProductTile();
          prod.CurrentPrize ="";//"$35.00";
          prod.HotLabel = "";
          prod.OldPrize = "";//"$55.00";
          prod.ProductTileImgURL1 = data[index].img1;//"../../../assets/styles/images/books/1.jpg";
          prod.ProductTileImgURL2 = data[index].img2;//"../../../assets/styles/images/books/1.jpg";
          //prod.ProductBlockImgURL = data[index].img3;//"../../../assets/styles/images/product/2.jpg";
          prod.ProductName = "";//"robin parrish";
          //prod.ProductURL = data[index].Link;
          //prod.ProductURL = "https://hideandskin.in/#/single-product/718&MA%201%20BRN%20PALE";

          prod.ProductURL = "http://integraff.com/ServicesIntegraff.html";
          prod.ItemId = data[index].ItemId;
          prod.SKUCode = data[index].SKUCode;
          prod.ProductDescription =
           "";

          //prod.CollectionName = "MensCollection";
          this.mensCollectionListLaptopBags[carouselIndex].push(prod);

        }
        this.isMensCollectionAvailable = true;
        console.log(JSON.stringify(this.mensCollectionListLaptopBags));

      });


    }


  }

  VIEWPARTNER_LINK(){

           //   stat -> 0 AF_ORDER   stat -> 1 AF_REVIEW

        //this.brandname="Amazon";
        this.skuname=this._SKUCODE_;

        //////////////////// ORDER /////////////////////////////////

        this.collservice.getAllAffiliatedLinksData('Amazon',this.skuname,0).subscribe((data: any) => {         
        
          this.COUNT=0;
          
         // for (let index = 0; index < data.length; index++) {
            if (  this.COUNT < data.length ) {

              this.partner_AMAZON_ORDER=true;                           

            }
            else{

              this.partner_AMAZON_ORDER=false;


            }

         //}
      

        });



        ////////////////////  REVIEW  ////////////////////////////

        this.collservice.getAllAffiliatedLinksData('Amazon',this.skuname,1).subscribe((data: any) => {         
        
          this.COUNT=0;
          
         // for (let index = 0; index < data.length; index++) {
            if (  this.COUNT < data.length ) {

              this.partner_AMAZON_REVIEW=true;                           

            }
            else{

              this.partner_AMAZON_REVIEW=false;


            }

         //}
      

        });





  }



  openWinAMAZONORDER() {
   

      //////////////////// 1
      // var newWindow = window.open(
      //   "http://localhost:4200/#/admin/productUnit",
      //   "_blank",
      //   "location=yes,height=570,width=620,scrollbars=yes,status=yes"
      // );


           //////////////////////////////// 2
          // var newWindow = window.open(
         //   "https://www.google.com/",
        //   "_blank",
       //   "location=yes,height=570,width=620,scrollbars=yes,status=yes"
      // );


            //  https://www.amazon.in/gp/product/B07GBZGDZM/ref=cx_skuctr_share?smid=A2P236AU2GWAU1


        //   stat -> 0 AF_ORDER   stat -> 1 AF_REVIEW

        
        this.brandname="Amazon";
        this.skuname=this._SKUCODE_;

        this.collservice.getAllAffiliatedLinksData('Amazon',this.skuname,0).subscribe((data: any) => {
         
          //prod.SKUCode = data[index].SKUCode;
          this.COUNT=0;
          
         // for (let index = 0; index < data.length; index++) {
            if (  this.COUNT < data.length ) {

              this.partner_AMAZON=true;

              //AffiliateLink
              this.Link = data[0].AffiliateLink;
              // this.Link ="https://www.amazon.in/gp/product/ B07MD1PPTF/ref=cx_skuctr_share?smid=A2P236AU2GWAU1";
              var newWindow = window.open(
              this.Link ,
              "_blank",
              "location=yes,height=570,width=900,scrollbars=yes,status=yes"
              );
             

            }
            else{

              this.partner_AMAZON=false;


            }

         //}
      

        });


            

            ///////////////////////////////  3
            // this.Link ="https://www.amazon.in/gp/product/ B07MD1PPTF/ref=cx_skuctr_share?smid=A2P236AU2GWAU1";
            // var newWindow = window.open(
            // this.Link ,
            // "_blank",
            // "location=yes,height=570,width=620,scrollbars=yes,status=yes"
            // );


      ////////////////////////////////// 4
     //var newWindow = window.open("http://localhost:4200/#/admin/productUnit");



  }
  

  openWinAMAZONREVIEW() {
   

    //////////////////// 1
    // var newWindow = window.open(
    //   "http://localhost:4200/#/admin/productUnit",
    //   "_blank",
    //   "location=yes,height=570,width=620,scrollbars=yes,status=yes"
    // );


         //////////////////////////////// 2
        // var newWindow = window.open(
       //   "https://www.google.com/",
      //   "_blank",
     //   "location=yes,height=570,width=620,scrollbars=yes,status=yes"
    // );


          //  https://www.amazon.in/gp/product/B07GBZGDZM/ref=cx_skuctr_share?smid=A2P236AU2GWAU1


      //   stat -> 0 AF_ORDER   stat -> 1 AF_REVIEW

      
      this.brandname="Amazon";
      this.skuname=this._SKUCODE_;

      this.collservice.getAllAffiliatedLinksData('Amazon',this.skuname,1).subscribe((data: any) => {
       
        //prod.SKUCode = data[index].SKUCode;
        this.COUNT=0;
        
       // for (let index = 0; index < data.length; index++) {
          if (  this.COUNT < data.length ) {

            this.partner_AMAZON=true;

            //AffiliateLink
            this.Link = data[0].AffiliateLink;
            // this.Link ="https://www.amazon.in/gp/product/ B07MD1PPTF/ref=cx_skuctr_share?smid=A2P236AU2GWAU1";
            var newWindow = window.open(
            this.Link ,
            "_blank",
            "location=yes,height=570,width=900,scrollbars=yes,status=yes"
            );
           

          }
          else{

            this.partner_AMAZON=false;


          }

       //}
    

      });


          

          ///////////////////////////////  3
          // this.Link ="https://www.amazon.in/gp/product/ B07MD1PPTF/ref=cx_skuctr_share?smid=A2P236AU2GWAU1";
          // var newWindow = window.open(
          // this.Link ,
          // "_blank",
          // "location=yes,height=570,width=620,scrollbars=yes,status=yes"
          // );


    ////////////////////////////////// 4
   //var newWindow = window.open("http://localhost:4200/#/admin/productUnit");



  }

  


  //   this._Status_='QV';     this._Status_='GE';

addToCart() {


  if (sessionStorage.getItem("OrderMaster_Id")) {
    var item = {
      Id: 0,
      OrderMaster_Id: parseInt(sessionStorage.getItem("OrderMaster_Id")),
      ApplicationItemCategoryId: 4,
      OrderStatusID: 2,
      OrderShippingCategoryID: 0,
      OrderPaymentTypeId: 0,
      PackingId: 0,
      TrackId: 0,
      SKUCode: this._SKUCODE_,
      Qty: 1,
      CreatedBy: 55,
      OperationType: "insert",
    };
    this.itemModifierService.addItemToCart(item).subscribe((event) => {
      if (event) {
        console.log(event);
        if (event[0].OperationStatus == "Successfully Saved") {
          alert("Add To Cart Successfully !");
          this.getCartInfo();
        }
      }
    });
  } else {
    alert("Please Login !!");
    this.router.navigateByUrl("login");
  }
}


addToCart2() {



 if (sessionStorage.getItem("OrderMaster_Id")) {
   var item = {
     Id: 0,
     OrderMaster_Id: parseInt(sessionStorage.getItem("OrderMaster_Id")),
     ApplicationItemCategoryId: 4,
     OrderStatusID: 2,
     OrderShippingCategoryID: 0,
     OrderPaymentTypeId: 0,
     PackingId: 0,
     TrackId: 0,
     SKUCode: this._SKUCODE_,
     Qty: 1,
     CreatedBy: 55,
     OperationType: "insert",
   };
   this.itemModifierService.addItemToCart(item).subscribe((event) => {
     if (event) {
       console.log(event);
       if (event[0].OperationStatus == "Successfully Saved") {
         alert("Add To Cart Successfully !");
         this.getCartInfo();
       }
     }
   });
 } else {
   alert("Please Login !!");
   this.router.navigateByUrl("login");
 }
}

addToWishlist() {
  if (sessionStorage.getItem("OrderMaster_Id")) {
    var item = {
      Id: 0,
      OrderMaster_Id: parseInt(sessionStorage.getItem("OrderMaster_Id")),
      ApplicationItemCategoryId: 3,
      OrderStatusID: 2,
      OrderShippingCategoryID: 0,
      OrderPaymentTypeId: 0,
      PackingId: 0,
      TrackId: 0,
      SKUCode: this._SKUCODE_,
      Qty: 1,
      CreatedBy: 55,
      OperationType: "insert",
    };
    this.itemModifierService.addItemToCart(item).subscribe((event) => {
      if (event) {
        console.log(event);
        if (event[0].OperationStatus == "Successfully Saved") {
          alert("Add To WishList Successfully !");
        }
      }
    });
  } else {
    alert("Please Login");
    this.router.navigateByUrl("login");
  }
}

getCartInfo() {
  if (sessionStorage.getItem("OrderMaster_Id")) {
    this.itemModifierService
      .getCartItems(parseInt(sessionStorage.getItem("OrderMaster_Id")))
      .subscribe((event: any) => {
        if (event.length > 0) {
          this.infoStore.setCartInfo(event);
        } else {
          this.infoStore.setCartInfo([]);
        }
      });
  } else {
    this.infoStore.setCartInfo([]);
  }
}

manageRes(data: any) {


  this.currentItem = data[0];
  this.currentItem.HotLabel = data[0].PrimaryTagName;
  this.currentItem.CurrentPrize = data[0].StrikePrice;
  this.currentItem.OldPrize = data[0].MaxRetailPrice;
  this.currentItem.SaveAmount = data[0].SaveAmount;
  this.currentItem.SavePercent = data[0].SavePercent;

     //  *ngIf="CAP"
    // this.CAP=true;
   

    
    if(  data[0].StockStatus == null  ||  data[0].StockStatus == '' )
    {

      // this.CAP=true;
     // this.CAP1=true;  
      this.CAP3=false;

      if(  data[0].PriceCaption == null )
      {

        // this.CAP=true;
        this.CAP1=true;this.CAP2=false;
        //this.CAP3=false;

      }
      else
      {

        // this.CAP=false;
        this.CAP1=false;this.CAP2=true;
        //this.CAP3=false;

      }


    }
    else
    {

      // this.CAP=false;
     // this.CAP1=false;this.CAP2=false;
      this.CAP3=true;

      if(  data[0].PriceCaption == null )
      {

        // this.CAP=true;
        this.CAP1=false;this.CAP2=false;
        // this.CAP3=false;

      }
      else
      {

        // this.CAP=false;
        this.CAP1=false;this.CAP2=false;
        // this.CAP3=false;

      }



    }

     // this.currentItem.HotLabel = data[0].SavePriceAmountDeal;
    // this.currentItem.OldPrize = data[0].SavePricePercentDeal;

    this.currentItem.ProductTileImgURL1 = data[0].img1; //"../../../assets/styles/images/books/1.jpg";
    this.currentItem.ProductTileImgURL2 = data[0].img2; //"../../../assets/styles/images/books/1.jpg";
    this.currentItem.ProductBlockImgURL = data[0].img3; //"../../../assets/styles/images/product/2.jpg";
    this.currentItem.ProductName = data[0].ItemName; //"robin parrish";
    this.currentItem.ProductURL = "#/single-product";
    this.currentItem.ItemId = data[0].ItemId;
    this.currentItem.SKUCode = data[0].SKUCode;

    this._SKUCODEG_= data[0].SKUCode;
    this._Status_='GE';

    //this.relatedProduct = data[0].RelatedProductStyle;
    this.relatedProduct ="STYLO1";

    this.currentItem.ImageList = data[0].ImgCollection.split("#");
    //this.currentItem.ImageList = data[0].img1;
    this.currentItem.ProductDescription =
      "Every HIDE & SKIN product has an elegant design ,"+
      "perfect size with a luxurious feel and good quality threading work"+
      "to keep up with consistent and long term use";
    let headerProps =  Object.keys(data[0]).filter((item) => {
      return item.startsWith("Header");
    });

    // headerProps.forEach(element => {

    //   if (data[0][element]&&data[0][element].startsWith("Description")) {
    //     let value=data[0][element].split("#")
    //     let str="".concat(value[1],"     :      ", value[2]);
    //     this.description.push(str);

    //   }
    // });

    // DescriptionINTRODUCTION : string = null;
    // DescriptionDURABLE : string = null;
    // DescriptionRFID : string = null;
    // DescriptionSMARTDESIGN : string = null;
    // DescriptionCOMPACT : string = null;
    // DescriptionGIFTING : string = null;



   // this.outermaterial = data[0].Header1.split("#")[2];

    // if(  data[0].outermaterial ==null ){
    //   this.outermaterial = " ";
    // }else{
    //   this.outermaterial = data[0].outermaterial.split("#")[2];
    // }

   // this.DescriptionINTRODUCTION = data[0].DescriptionINTRODUCTION.split("#")[2];


  //   if(  data[0].Description1 ==null ){
  //     this.Description1 = " ";
  //   }else{
  //     this.DescriptionINTRODUCTION = data[0].DescriptionINTRODUCTION.split("#")[2];
  //   }

  //   // this.DescriptionCOMPACT = data[0].DescriptionCOMPACT.split("#")[2];
  //   if(  data[0].DescriptionCOMPACT ==null ){
  //     this.DescriptionCOMPACT = " ";
  //   }else{
  //     this.DescriptionCOMPACT = data[0].DescriptionCOMPACT.split("#")[2];
  //   }


  //   // this.DescriptionSMARTDESIGN = data[0].DescriptionSMARTDESIGN.split("#")[2];
  //   if(  data[0].DescriptionSMARTDESIGN ==null ){
  //     this.DescriptionSMARTDESIGN = " ";
  //   }else{
  //     this.DescriptionSMARTDESIGN = data[0].DescriptionSMARTDESIGN.split("#")[2];
  //   }


  //   // this.DescriptionDURABLE = data[0].DescriptionDURABLE.split("#")[2];
  //   if(  data[0].DescriptionDURABLE ==null ){
  //     this.DescriptionDURABLE = " ";
  //   }else{
  //     this.DescriptionDURABLE = data[0].DescriptionDURABLE.split("#")[2];
  //   }


  //   // this.DescriptionRFID = data[0].DescriptionRFID.split("#")[2];
  //   if(  data[0].DescriptionRFID ==null ){
  //     this.DescriptionRFID = " ";
  //   }else{
  //     this.DescriptionRFID = data[0].DescriptionRFID.split("#")[2];
  //   }


  //  // this.DescriptionGIFTING = data[0].DescriptionGIFTING.split("#")[2];
  //   if(  data[0].DescriptionGIFTING ==null ){
  //     this.DescriptionGIFTING = " ";
  //   }else{
  //     this.DescriptionGIFTING = data[0].DescriptionGIFTING.split("#")[2];
  //   }



  //   if(  data[0].GIFTINGSOLUTIONFORMEN ==null ){
  //     this.GIFTINGSOLUTIONFORMEN = " ";
  //   }else{
  //     this.GIFTINGSOLUTIONFORMEN = data[0].GIFTINGSOLUTIONFORMEN.split("#")[2];
  //   }
  //   if(  data[0].Genuineleather ==null ){
  //     this.Genuineleather = " ";
  //   }else{
  //     this.Genuineleather = data[0].Genuineleather.split("#")[2];
  //   }
  //   if(  data[0].Adjustablesize ==null ){
  //     this.Adjustablesize = " ";
  //   }else{
  //     this.Adjustablesize = data[0].Adjustablesize.split("#")[2];
  //   }
  //   if(  data[0].MATERIALANDDESIGEN ==null ){
  //     this.MATERIALANDDESIGEN = " ";
  //   }else{
  //     this.MATERIALANDDESIGEN = data[0].MATERIALANDDESIGEN.split("#")[2];
  //   }
  //   if(  data[0].MECHANISM ==null ){
  //     this.MECHANISM = " ";
  //   }else{
  //     this.MECHANISM = data[0].MECHANISM.split("#")[2];
  //   }
  //   if(  data[0].NewMechanism ==null ){
  //     this.NewMechanism = " ";
  //   }else{
  //     this.NewMechanism = data[0].NewMechanism.split("#")[2];
  //   }


    // GIFTINGSOLUTIONFORMEN : string = null;
    // Genuineleather : string = null;
    // Adjustablesize : string = null;
    // MATERIALANDDESIGEN : string = null;
    // MECHANISM : string = null;
    // NewMechanism : string = null;


    // SpeciModelNumber : string = null;
    // SpeciItemHeight : string = null;
    // SpeciItemLength : string = null;
    // SpeciItemWidth : string = null;
    // SpeciItemWeight : string = null;
    // SpeciMaterial : string = null;
    // SpeciSpecialFeatures : string = null;
    // SpeciInnerMaterial : string = null;
    // SpeciWarrantyDescription : string = null;
    // SpeciWarrantyType : string = null;
    // SpeciProductDimensions : string = null;


     //////////////////////////  Description //////////////////////////


    if(  data[0].Description1 ==null ){

      this.Description1 = null;
      this.Description11 = null;

    }
    else {

      this.Description1 = data[0].Description1.split("#")[1];
      this.Description11 = data[0].Description1.split("#")[2];

    }


    if(  data[0].Description2 ==null ){

      this.Description2 = null;
      this.Description22 = null;

    }
    else {

      this.Description2 = data[0].Description2.split("#")[1];
      this.Description22 = data[0].Description2.split("#")[2];

    }


    if(  data[0].Description3 ==null ){

      this.Description3 = null;
      this.Description33 = null;

    }
    else {

      this.Description3 = data[0].Description3.split("#")[1];
      this.Description33 = data[0].Description3.split("#")[2];

    }


    if(  data[0].Description4 ==null ){

      this.Description4 = null;
      this.Description44 = null;

    }
    else {

      this.Description4 = data[0].Description4.split("#")[1];
      this.Description44 = data[0].Description4.split("#")[2];

    }


    if(  data[0].Description5 ==null ){

      this.Description5 = null;
      this.Description55 = null;

    }
    else {

      this.Description5 = data[0].Description5.split("#")[1];
      this.Description55 = data[0].Description5.split("#")[2];

    }


    if(  data[0].Description6 ==null ){

      this.Description6 = null;
      this.Description66 = null;

    }
    else {

      this.Description6 = data[0].Description6.split("#")[1];
      this.Description66 = data[0].Description6.split("#")[2];

    }


    if(  data[0].Description7 ==null ){

      this.Description7 = null;
      this.Description77 = null;

    }
    else {

      this.Description7 = data[0].Description7.split("#")[1];
      this.Description77 = data[0].Description7.split("#")[2];

    }

    if(  data[0].Description8 ==null ){

      this.Description8 = null;
      this.Description88 = null;

    }
    else {

      this.Description8 = data[0].Description8.split("#")[1];
      this.Description88 = data[0].Description8.split("#")[2];

    }


    if(  data[0].Description9 ==null ){

      this.Description9 = null;
      this.Description99 = null;

    }
    else {

      this.Description9 = data[0].Description9.split("#")[1];
      this.Description99 = data[0].Description9.split("#")[2];

    }


    if(  data[0].Description10 ==null ){

      this.Description10 = null;
      this.Description100 = null;

    }
    else {

      this.Description10 = data[0].Description10.split("#")[1];
      this.Description100 = data[0].Description10.split("#")[2];

    }


    //////////////////////////  Description //////////////////////////

    if(  data[0].SpeciModelNumber ==null ){
      this.SpeciModelNumber = " ";
    }else{
      this.SpeciModelNumber = data[0].SpeciModelNumber.split("#")[2];
    }

    if(  data[0].SpeciModelNumber ==null ){
      this.SpeciModelNumber = " ";
    }else{
      this.SpeciModelNumber = data[0].SpeciModelNumber.split("#")[2];
    }

    if(  data[0].SpeciItemHeight ==null ){
      this.SpeciItemHeight = " ";
    }else{
      this.SpeciItemHeight = data[0].SpeciItemHeight.split("#")[2];
    }

    if(  data[0].SpeciItemLength ==null ){
      this.SpeciItemLength = " ";
    }else{
      this.SpeciItemLength = data[0].SpeciItemLength.split("#")[2];
    }

    if(  data[0].SpeciItemWidth ==null ){
      this.SpeciItemWidth = " ";
    }else{
      this.SpeciItemWidth = data[0].SpeciItemWidth.split("#")[2];
    }

    if(  data[0].SpeciItemWeight ==null ){
      this.SpeciItemWeight = " ";
    }else{
      this.SpeciItemWeight = data[0].SpeciItemWeight.split("#")[2];
    }

    if(  data[0].SpeciMaterial ==null ){
      this.SpeciMaterial = " ";
    }else{
      this.SpeciMaterial = data[0].SpeciMaterial.split("#")[2];
    }

    if(  data[0].SpeciSpecialFeatures ==null ){
      this.SpeciSpecialFeatures = " ";
    }else{
      this.SpeciSpecialFeatures = data[0].SpeciSpecialFeatures.split("#")[2];
    }


    if(  data[0].SpeciInnerMaterial ==null ){
      this.SpeciInnerMaterial = " ";
    }else{
      this.SpeciInnerMaterial = data[0].SpeciInnerMaterial.split("#")[2];
    }

    if(  data[0].SpeciWarrantyDescription ==null ){
      this.SpeciWarrantyDescription = " ";
    }else{
      this.SpeciWarrantyDescription = data[0].SpeciWarrantyDescription.split("#")[2];
    }


    if(  data[0].SpeciWarrantyType ==null ){
      this.SpeciWarrantyType = " ";
    }else{
      this.SpeciWarrantyType = data[0].SpeciWarrantyType.split("#")[2];
    }

    if(  data[0].SpeciProductDimensions ==null ){
      this.SpeciProductDimensions = " ";
    }else{
      this.SpeciProductDimensions = data[0].SpeciProductDimensions.split("#")[2];
    }


    //this.SpeciModelNumber = data[0].SpeciModelNumber.split("#")[2];
    //this.SpeciItemHeight = data[0].SpeciItemHeight.split("#")[2];
    // this.SpeciItemLength = data[0].SpeciItemLength.split("#")[2];
    // this.SpeciItemWidth = data[0].SpeciItemWidth.split("#")[2];
    // this.SpeciItemWeight = data[0].SpeciItemWeight.split("#")[2];
    // this.SpeciMaterial = data[0].SpeciMaterial.split("#")[2];
    // this.SpeciSpecialFeatures = data[0].SpeciSpecialFeatures.split("#")[2];
    // this.SpeciInnerMaterial = data[0].SpeciInnerMaterial.split("#")[2];
    // this.SpeciWarrantyDescription = data[0].SpeciWarrantyDescription.split("#")[2];
    // this.SpeciWarrantyType = data[0].SpeciWarrantyType.split("#")[2];
    // this.SpeciProductDimensions = data[0].SpeciProductDimensions.split("#")[2];




     // ImportantPointsLEGAL : string = null;
     // ImportantPointsSAFETY : string = null;

     if(  data[0].ImportantPointsLEGAL ==null ){
      this.ImportantPointsLEGAL = " ";
    }else{
      this.ImportantPointsLEGAL = data[0].ImportantPointsLEGAL.split("#")[2];
    }

    if(  data[0].ImportantPointsSAFETY ==null ){
      this.ImportantPointsSAFETY = " ";
    }else{
      this.ImportantPointsSAFETY = data[0].ImportantPointsSAFETY.split("#")[2];
    }


    this.showProductDetails = true;

    this.onViewUpsellProductAll();
    this.onViewRelatedProductAll();


}

addTocontact(){

  
}


ngOnDestroy() {
    this.sub.unsubscribe();
}

  
imgChange(data){
    this.showPic=false;
    setTimeout(() => {
      this.showPic=true;
    }, 300);

}

  getIdForThumbs(index){
    return "carousel-selector-"+index;
  }

  getIdForImage(index){
    return "myimage-"+index;
  }

  getDataSlideForThumbs(index){
    return index;
  }

  imageZoom(imgID, resultID) {
    var img, lens, result, cx, cy;
    img = document.getElementById(imgID);
    result = document.getElementById(resultID);
    result.style.display="block";
    /*create lens:*/
    document.querySelectorAll('.img-zoom-lens').forEach(function(a){
      a.remove()
      })
    lens = document.createElement("DIV");
    lens.setAttribute("class", "img-zoom-lens");
    /*insert lens:*/
    img.parentElement.insertBefore(lens, img);
    lens.style.position="absolute";
    lens.style.width="200px";
    lens.style.height="200px";
    /*calculate the ratio between result DIV and lens:*/
    cx = result.offsetWidth / lens.offsetWidth;
    cy = result.offsetHeight / lens.offsetHeight;
    /*set background properties for the result DIV:*/
    result.style.backgroundImage = "url('" + img.src + "')";
    result.style.backgroundSize = (img.width * cx) + "px " + (img.height * cy) + "px";
    /*execute a function when someone moves the cursor over the image, or the lens:*/
    lens.addEventListener("mousemove", moveLens);
    img.addEventListener("mousemove", moveLens);
    /*and also for touch screens:*/
    lens.addEventListener("touchmove", moveLens);
    img.addEventListener("touchmove", moveLens);
    function moveLens(e) {
      var pos, x, y;
      /*prevent any other actions that may occur when moving over the image:*/
      e.preventDefault();
      /*get the cursor's x and y positions:*/
      pos = getCursorPos(e);
      /*calculate the position of the lens:*/
      x = pos.x - (lens.offsetWidth / 2);
      y = pos.y - (lens.offsetHeight / 2);
      /*prevent the lens from being positioned outside the image:*/
      if (x > img.width - lens.offsetWidth) { x = img.width - lens.offsetWidth; }
      if (x < 0) { x = 0; }
      if (y > img.height - lens.offsetHeight) { y = img.height - lens.offsetHeight; }
      if (y < 0) { y = 0; }
      /*set the position of the lens:*/
      lens.style.left = x + "px";
      lens.style.top = y + "px";
      /*display what the lens "sees":*/
      result.style.backgroundPosition = "-" + (x * cx) + "px -" + (y * cy) + "px";
    }
    function getCursorPos(e) {
      var a, x = 0, y = 0;
      e = e || window.event;
      /*get the x and y positions of the image:*/
      a = img.getBoundingClientRect();
      /*calculate the cursor's x and y coordinates, relative to the image:*/
      x = e.pageX - a.left;
      y = e.pageY - a.top;
      /*consider any page scrolling:*/
      x = x - window.pageXOffset;
      y = y - window.pageYOffset;
      return { x: x, y: y };
    }
  }

  removeImageZoom(resultID){
    var result = document.getElementById(resultID);
    document.querySelectorAll('.img-zoom-lens').forEach(function(a){
      a.remove()
      })
    result.style.display="none";
   //console.log("Removed");
  }








  onViewRelatedProductAll(){

    //New Products /  New Arrivals

    this.str =this.relatedProduct;
    this.sliderService.getAllRelatedProductsData(this.str).subscribe((data: any) => {

    this.showRelatedProductDetails=false;

     let newProductcarouselIndex=0;this.relatedProductTileList[newProductcarouselIndex]=[];
     for (let index = 0; index < data.length; index++) {
       if (index!==0&&index%4==0) {
         newProductcarouselIndex=newProductcarouselIndex+1;
         this.relatedProductTileList[newProductcarouselIndex]=[];
       }
       let prod = new ProductTile();
       prod.CurrentPrize = "Rs."+ " "+data[index].StrikePrice;//"$35.00";
       prod.HotLabel = "NEW";
       prod.OldPrize ="Rs."+" "+ data[index].MaxRetailPrice;//"$55.00";
       prod.ProductTileImgURL1 = data[index].img1;//"../../../assets/styles/images/books/1.jpg";
       prod.ProductTileImgURL2 = data[index].img2;//"../../../assets/styles/images/books/1.jpg";
       prod.ProductBlockImgURL = data[index].img3;//"../../../assets/styles/images/product/2.jpg";
       prod.ProductName = data[index].ItemName;//"robin parrish";
       prod.ProductURL = "#/single-product";
       prod.ItemId = data[index].ItemId;
       prod.SKUCode= data[index].SKUCode;
       prod.ProductDescription =
         "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam "+
         "fringilla augue nec est tristique auctor. Donec non est at libero "+
         "vulputate rutrum. Morbi ornare lectus quis justo gravida semper. "+
         "Nulla tellus mi, vulputate adipiscing cursus eu, suscipit id nulla.";
         prod.CollectionName = "RelatedCollection";

         if(  data[index].PriceCaption == '' )
         {
     
           this.CAP=true;
     
         }
         else
         {
     
           this.CAP=false;
     
         }

       this.relatedProductTileList[newProductcarouselIndex].push(prod);

       // *ngIf="CAP"
      // this.CAP=true;

    



     }

       this.showRelatedProductDetails=true;

   });



   }

   onViewUpsellProductAll(){

    //New Products /  New Arrivals
    this.sliderService.getAllUpSellingData().subscribe((data: any) => {

      this.showUPSELLProductDetails =false;

     let newProductcarouselIndex=0;this.upsellProductTileList[newProductcarouselIndex]=[];
     for (let index = 0; index < data.length; index++) {
       if (index!==0&&index%4==0) {
         newProductcarouselIndex=newProductcarouselIndex+1;
         this.upsellProductTileList[newProductcarouselIndex]=[];
       }
       let prod = new ProductTile();
       prod.CurrentPrize = "Rs."+ " "+data[index].StrikePrice;//"$35.00";
       prod.HotLabel = "NEW";
       prod.OldPrize ="Rs."+" "+ data[index].MaxRetailPrice;//"$55.00";
       prod.ProductTileImgURL1 = data[index].img1;//"../../../assets/styles/images/books/1.jpg";
       prod.ProductTileImgURL2 = data[index].img2;//"../../../assets/styles/images/books/1.jpg";
       prod.ProductBlockImgURL = data[index].img3;//"../../../assets/styles/images/product/2.jpg";
       prod.ProductName = data[index].ItemName;//"robin parrish";
       prod.ProductURL = "#/single-product";
       prod.ItemId = data[index].ItemId;
       prod.SKUCode= data[index].SKUCode;
       prod.ProductDescription =
         "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam "+
         "fringilla augue nec est tristique auctor. Donec non est at libero "+
         "vulputate rutrum. Morbi ornare lectus quis justo gravida semper. "+
         "Nulla tellus mi, vulputate adipiscing cursus eu, suscipit id nulla.";
       prod.CollectionName = "UpSellCollection";

       if(  data[index].PriceCaption == '' )
       {
   
         this.CAP=true;
   
       }
       else
       {
   
         this.CAP=false;
   
       }

       this.upsellProductTileList[newProductcarouselIndex].push(prod);

       // *ngIf="CAP"
      // this.CAP=true;

      


     }

     // this.isNewProductAvailable=true;
     this.showUPSELLProductDetails =false;


   });



   }





  quickView(collectionName) {
  this.showQuickView = false;
  const skus = collectionName.split("&")[0];
  this._SKUCODE_=collectionName.split("&")[0];
  //this._Status_='QV';

  const collection = collectionName.split("&")[1];
  this.currentQuickView = null;
  switch (collection) {
    case "RelatedCollection":
      this.relatedProductTileList.forEach((element) => {
        element.forEach((item) => {
          if (item.SKUCode == skus) {
            this.currentQuickView = item;
            this.showQuickView = true;
          }
        });
      });
      break;

      case "UpSellCollection":
      this.upsellProductTileList.forEach((element) => {
        element.forEach((item) => {
          if (item.SKUCode == skus) {
            this.currentQuickView = item;
            this.showQuickView = true;
          }
        });
      });
      break;


    default:
      break;
  }

  }




}
